import React from 'react';
import formatDate from 'date-fns/format';
import parse from 'date-fns/parse';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import TimePicker, { FORMAT_24H } from '@/components/TimePicker';

import { FrequencyComponentProps } from '../../types';
import FrequencyInput from '../InputComponents/Frequency';
import WeekdaysInput from '../InputComponents/Weekdays';
import WeeksOfMonthInput from '../InputComponents/WeeksOfMonth';

const Monthly = ({
  value,
  onChange,
  hideTimeSelection,
  disabled,
  allowedFrequencies,
  errorConfig,
  size,
}: FrequencyComponentProps) => {
  const { t } = useTranslation();

  const displayValue = parse(value.time, FORMAT_24H, new Date());
  return (
    <Stack direction="col" gapY={16}>
      <Stack justifyContent="between">
        <FrequencyInput
          allowedFrequencies={allowedFrequencies}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
        <Typography
          className={cn('mx-12 my-auto', { 'pb-24': Boolean(errorConfig?.weeksOfMonth) })}
          variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
          {t('On')}
        </Typography>
        <WeeksOfMonthInput
          disabled={disabled}
          error={errorConfig?.weeksOfMonth}
          size={size}
          value={value}
          onChange={onChange}
        />
      </Stack>
      <Stack>
        <WeekdaysInput
          disabled={disabled}
          error={errorConfig?.daysOfWeek}
          fullWidth={hideTimeSelection}
          size={size}
          value={value}
          onChange={onChange}
        />
        {hideTimeSelection ? null : (
          <>
            <Typography
              className={cn('mx-12 my-auto', { 'pb-24': Boolean(errorConfig?.daysOfWeek) })}
              variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
              {t('At')}
            </Typography>
            <TimePicker
              className="w-1/2"
              disabled={disabled}
              size={size}
              value={displayValue}
              onChange={(date) => {
                onChange({ ...value, time: formatDate(date, FORMAT_24H) });
              }}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default Monthly;
